import MaintenanceWorkflowForwardingOnDirectiveEntry from "../../pages/Show/components/tabs/forwardingsTab/states/OnDirectiveEntry";
import MaintenanceWorkflowForwardingOnGoingCheckin from "../../pages/Show/components/tabs/forwardingsTab/states/OnGoingCheckin";
import MaintenanceWorkflowForwardingOnGoingEstablishmentChoice from "../../pages/Show/components/tabs/forwardingsTab/states/OnGoingEstablishmentChoice";
import { MaintenanceForwardingSectionsProps, MaintenanceForwardingStatus } from "../../types/forwardings/maintenanceForwarding.type";

export const maintenanceForwardingStatus: Record<MaintenanceForwardingStatus, {
  label: string;
  component: React.ComponentType<MaintenanceForwardingSectionsProps> | null;
}> = {
  canceled: {
    label: 'Declinado',
    component: MaintenanceWorkflowForwardingOnGoingEstablishmentChoice,
  },
  ongoing_establishment_choice: {
    label: 'Aguardando resposta do estabelecimento',
    component: MaintenanceWorkflowForwardingOnGoingEstablishmentChoice,
  },
  ongoing_checkin: {
    label: 'Pendente de check-in',
    component: MaintenanceWorkflowForwardingOnGoingCheckin,
  },
  ongoing_directive: {
    label: 'Análise de diagnóstico e orçamento',
    component: MaintenanceWorkflowForwardingOnDirectiveEntry,
  },
}
